import React from 'react';
import { useIntl } from 'react-intl';
import { getHomeAutomationApiUrl } from '../../../helpers/url';
import { Device, Measurement } from '../../../types/home-automation/model';
import List from '../../List/List';

interface BatteryVoltageProps {
    date: string;
    device: Device;
}

const url = getHomeAutomationApiUrl('measurements');

export default ({ date, device }: BatteryVoltageProps) => {
    const { formatMessage } = useIntl();
    const title = formatMessage({ defaultMessage: 'Battery voltage', id: 'battery-voltage.title' });

    return <List params={{ date, device: device.slug, type: 'battery-voltage' }} title={title} url={url}
        renderItem={(measurement: Measurement) => <div key={measurement.id} className="toast show">
            <div className="toast-header">
                <strong className="mr-auto">
                    {measurement.value}mV
                    {measurement.series ? <em className="ml-2">{measurement.series}</em> : null}
                </strong>
                <small className="text-muted">{(new Date(measurement.time)).toLocaleTimeString()}</small>
            </div>
        </div>} />;
}
